import Moon from './Moon.vue';

export default Moon;
